import React from 'react';
import HeroSection from './components/HeroSection/HeroSection';
import ContactForm from './components/ContactForm/ContactForm';
import ContactInfo from './components/ContactInfo/ContactInfo';
import { Helmet } from 'react-helmet';
import './Contact.css';

const Contact = () => {
  return (
    <>      <Helmet>
            <title>Contact</title>
            <meta name="description" content="Welcome to Gladious – experts in sustainable and modern construction projects." />
          </Helmet>
    <div className="landing-page">
      {/* Hero Section */}
      <HeroSection />
      
      
      {/* Contact Form & Info Section */}
      <div className="contact-section">
        <div className="container">
          <div className="contact-container">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </div>
    </div>
  </>
  );
}

export default Contact;